/**
 * 將輸入的 array 依據目標 key 進行排序
 * <此 function 會直接改變 array>
 *
 * @param {array} array
 * @param {string} key
 * @param {boolean} [ascending]
 */

export function sortByKey(array, key, ascending = true) {
    if (ascending) {
        array.sort(function (a, b) {
            var x = a[key]
            var y = b[key]
            return x < y ? -1 : x > y ? 1 : 0
        })
    } else {
        array.sort(function (a, b) {
            var x = a[key]
            var y = b[key]
            return x > y ? -1 : x < y ? 1 : 0
        })
    }
}

/**
 * 將輸入的 array 依據目標 keyword 進行排序  \
 * <此 function 會回傳一個全新的 array>
 *
 * @param {array} array
 * @param {string} keyword
 * @return {array} newArr
 */
export function searchByKeyword(array, keyword) {
    if (!keyword) return array
    let newArr = []
    for (let obj of array) {
        for (let key of Object.keys(obj)) {
            if (typeof obj[key] !== 'string') continue
            if (obj[key].includes(keyword)) {
                newArr.push(obj)
                break
            }
        }
    }
    return newArr
}

/**
 * 將輸入的 array 針對目標 key 進行過濾  \
 * 如果 items 為空陣列則回傳原矩陣  \
 * <此時回傳的會指向原本的 array>  \
 * 若 items 有值則回傳所有 value 在 items 中的項目  \
 * <此 function 會回傳一個全新的 array>
 *
 * @param {array} array
 * @param {string} key
 * @param {array} items
 * @return {array} newArr
 */
export function filterByItems(array, key, items) {
    if (items.length === 0) return array
    let newArr = []
    for (let obj of array) {
        if (items.includes(obj[key])) newArr.push(obj)
    }
    return newArr
}
